import { RegisterKiwisaverComponent } from './register-kiwisaver.component';
import { RegisterDefaultComponent } from './register-default.component';
import { DynamicComponentHostDirective } from './../../shared/dynamic-component-loader/dynamic-component-host.directive';
import { Component, OnInit, OnDestroy, ViewChild, ComponentRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { Features } from 'src/app/models/features';
import { IRegistrationSettings } from 'src/app/models/featuresConfig';


export const registrationFormComponents = {
  "default": RegisterDefaultComponent,
  "kiwisaverRegistration": RegisterKiwisaverComponent,
};

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"]
})
export class RegisterComponent implements OnInit {
  @ViewChild(DynamicComponentHostDirective, { static: true }) dynamicComponentHost: DynamicComponentHostDirective;
  public componentRef: ComponentRef<any>;
  public loadedComponent: any;
  public companyName: string;
  public registrationWelcomeTitle: string;
  public registrationWelcomeBlurb: string;
  constructor(public componentFactoryResolver: ComponentFactoryResolver, private appConfig: AppConfig) { }

  private loadDynamicComponent(component: any, data: any = null) {
    return new Promise((resolve, reject) => {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
      const viewContainerRef: ViewContainerRef = (this.dynamicComponentHost) ? this.dynamicComponentHost.viewContainerRef : null;
      viewContainerRef.clear();
      if (this.dynamicComponentHost) {
        this.componentRef = viewContainerRef.createComponent(componentFactory);
        this.componentRef.instance.drillDownRef = this;
        resolve('component loaded');
      } else {
        reject('no host for component. add de component host directive to the template');
      }
    });
  }

  ngOnInit() {
    this.companyName = this.appConfig.getEnvironment().companyName;
    const registrationConfigFeature = this.appConfig.getSection(Features.REGISTRATION) as IRegistrationSettings;
    let registrationFormComponentId = "";
    if (registrationConfigFeature) {
      registrationFormComponentId = (registrationConfigFeature.component) ? registrationConfigFeature.component : "";
      this.registrationWelcomeTitle = (!!registrationConfigFeature.welcomeTitle) ? registrationConfigFeature.welcomeTitle : `Welcome to ${this.companyName}`;
      this.registrationWelcomeBlurb = (!!registrationConfigFeature.welcomeBlurb) ? registrationConfigFeature.welcomeBlurb : "Let’s  get  you  registered  so  you can begin setting up your account and start investing!";
    }
    const registrationFormComponent = (registrationFormComponentId !== "") ? registrationFormComponents[registrationFormComponentId] : registrationFormComponents["default"];
    if (registrationFormComponent) {
      this.loadDynamicComponent(registrationFormComponent);
    }

  }

}
